















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class VideoIdTable extends Vue {
  @Prop()
  public videoIds: string[];

  @Prop()
  public tableTitle: string;
}
